import React, { Component } from 'react';
import { connect, } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Dropdown from 'react-bootstrap/Dropdown'
import { Link, } from 'react-router-dom';
import { withRouter } from '../withRouter';
import { logout } from "actions/auth.js";
import styles from "components/Layout/NavStyles.module.scss";
import { pickImage } from "helpers/webpSupport";
import logoFallback from '../../images/logo.png';
import logoWebp from '../../images/logo.webp';
import basketIconFallback from '../../images/icons/basketIcon.png';
import basketIconWebp from '../../images/icons/basketIcon.webp';
import burgerMenuFallback from '../../images/icons/burgerMenu.png';
import burgerMenuWebp from '../../images/icons/burgerMenu.webp';
import userIconFallback from '../../images/icons/userIcon.png';
import userIconWebp from '../../images/icons/userIcon.webp';
import newsletterIconFallback from "images/icons/NewsletterIcon.png";
import newsletterIconWebp from "images/icons/NewsletterIcon.webp";
import { APP_TYPES } from "constants/AppTypes";
import { CONNECT_ENABLED } from "constants/FeatureFlags";
import CRMModal from 'components/Modals/CRMModal/CRMModal';

const logo = pickImage(logoWebp, logoFallback);
const basketIcon = pickImage(basketIconWebp, basketIconFallback);
const burgerMenu = pickImage(burgerMenuWebp, burgerMenuFallback);
const userIcon = pickImage(userIconWebp, userIconFallback);
const newsletterIcon = pickImage(newsletterIconWebp, newsletterIconFallback);



class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.getUrl();

        this.state = {
            showUserMenu: false,
            showCRM: false,
            mobileMenuOpen: false,
            // Horizontal shift applied to the centred white .navLinks pill to
            // avoid overlap with the PlayerList sidebar when both are visible.
            // Computed at runtime via measureNavCollision.
            navLinksShift: 0,
        };
        this.wrapperRefOne = React.createRef();
        this.wrapperRefTwo = React.createRef();
        this.userButtonRef = React.createRef();
        this.menuButtonRef = React.createRef();
        this.navLinksRef = React.createRef();
    }

    componentDidMount() {
        this.measureNavCollision();
        // Re-measure on viewport resize. The sidebar's width scales with
        // viewport height (vh-based formula in PlayerList.module.scss), so
        // resize is the primary signal we need to watch.
        this._onResize = () => this.measureNavCollision();
        window.addEventListener("resize", this._onResize);
    }

    componentDidUpdate(prevProps) {
        // Re-measure when the sidebar's visibility changes — that's the only
        // other axis that can cause overlap to appear or disappear.
        const prevVisible = prevProps.room.roomOpen && prevProps.room.isHost;
        const currVisible = this.props.room.roomOpen && this.props.room.isHost;
        if (prevVisible !== currVisible) {
            // PlayerList's `.sideBar` has a 1s slide-in transition, so a single
            // rAF measure would happen while the sidebar is still translated
            // off-screen and report zero overlap. Sample a few times across
            // the transition so the final shift settles correctly.
            requestAnimationFrame(() => this.measureNavCollision());
            this._navTransitionTimers = [200, 500, 1050].map(ms =>
                setTimeout(() => this.measureNavCollision(), ms)
            );
        }
    }

    componentWillUnmount() {
        if (this._onResize) window.removeEventListener("resize", this._onResize);
        if (this._navTransitionTimers) this._navTransitionTimers.forEach(clearTimeout);
    }

    /**
     * Push the centred white nav pill rightwards if the PlayerList sidebar
     * would otherwise overlap it. The pill is positioned with
     * `left: 50%; transform: translate(-50%, -50%)` so it floats relative to
     * the viewport centre; we shift it by adding a marginLeft offset equal to
     * the overlap distance plus a small buffer.
     *
     * Measured rather than calculated because the pill's content width varies
     * with breakpoint (gap/padding changes) and the sidebar's CSS width
     * formula is vh-based — JS measurement is the only way to get an exact
     * answer for arbitrary viewport sizes.
     */
    measureNavCollision = () => {
        const navLinks = this.navLinksRef.current;
        if (!navLinks) {
            if (this.state.navLinksShift !== 0) this.setState({ navLinksShift: 0 });
            return;
        }
        // Find the sidebar by its scoped className (CSS-modules-hashed, so we
        // match by substring). Only consider it when it's actually visible —
        // the .visible class is toggled by PlayerList based on roomOpen.
        const sidebar = document.querySelector('[class*="sideBar"][class*="visible"]:not([class*="collapse"])');
        if (!sidebar) {
            if (this.state.navLinksShift !== 0) this.setState({ navLinksShift: 0 });
            return;
        }
        const sidebarRect = sidebar.getBoundingClientRect();
        const navRect = navLinks.getBoundingClientRect();
        // Compute the pill's natural (un-shifted) left by subtracting the
        // currently applied marginLeft. Otherwise applying a shift would also
        // grow the measured overlap on subsequent frames.
        const BUFFER = 40;
        const naturalLeft = navRect.left - this.state.navLinksShift;
        const desiredLeft = sidebarRect.right + BUFFER;
        const shift = Math.max(0, desiredLeft - naturalLeft);
        if (shift !== this.state.navLinksShift) {
            this.setState({ navLinksShift: shift });
        }
    };


    showUserMenu = () => {
        this.setState({ showUserMenu: true });
    }

    hideUserMenu = () => {
        this.setState({ showUserMenu: false });
    }

    toggleUserMenu = (e) => {
        console.log("user menu");
        this.setState({ showUserMenu: !this.state.showUserMenu });
    }

    isMenuShowing = () => {
        return this.state.showMenu ? styles.show : styles.hide;
    }

    getUrl = () => {
        return window.location.href;
    }


    navigateToBundles = () => {
        if (window.location.pathname === "/") {
            const el = document.getElementById("bundles");
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
                return;
            }
        }
        this.props.navigate("/#bundles");
    }

    doNavigation = (page) => {
        this.props.navigate(page);
    }

    logout = (e) => {
        e.preventDefault();
        this.props.logout();
        this.props.navigate("/login");
    }

    countCartQuanity = () => {
        // Counts the quantity of items in the cart

        // The last thing to get this working is for this method to run whenever the cart updates

        if (this.props.cart) {
            const cart = this.props.cart;
            let total = 0;

            cart.items.forEach(item => {
                total += item.quantity
            })

            return total;
        } else {
            return 0;
        }

    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    onCRMClose = () => {
        this.setState({ showCRM: false, })
    }

    render() {
        const pathname = window.location.pathname;
        const limitAccessFireTv = this.props.room?.roomState?.platform === APP_TYPES.FIRE_TV || this.props.room?.roomState?.platform === APP_TYPES.SAMSUNG || this.props.devices.limitAccessFireTv;
        const isCurrentUserTheHost = this.props.auth.isLoggedIn &&
            this.props.auth.user?.email &&
            this.props.room?.roomState?.host?.email &&
            this.props.auth.user.email.toLowerCase() === this.props.room.roomState.host.email.toLowerCase();
        const sidebarExpanded = this.props.room.roomOpen && this.props.room.isHost && pathname.includes("/lobby");
        return (
            <>
                <header className={styles.header}>
                    <Container fluid className={`${styles.headerInner} ${this.state.mobileMenuOpen ? styles.menuOpen : ''}`}>
                        <div className={`${styles.logo}`} style={sidebarExpanded ? { opacity: 0, pointerEvents: 'none' } : undefined}>
                            <img onClick={() => !limitAccessFireTv && this.doNavigation("/")} src={logo} alt="" width="153" height="80"></img>
                        </div>
                        {
                            !pathname.includes("play") && !limitAccessFireTv &&
                            <nav
                                ref={this.navLinksRef}
                                className={`${styles.navLinks} d-none d-lg-flex`}
                                style={this.state.navLinksShift ? { marginLeft: `${this.state.navLinksShift}px` } : undefined}
                            >
                                <Link to="/help" className={styles.navLink}>How it works</Link>
                                <Link to="/shop" className={styles.navLink}>Browse all games</Link>
                                <Link to="/articles" className={styles.navLink}>News</Link>
                                <Link to="/go" className={styles.navLink}>On the Go</Link>
                                <Link to="/redeem-code" className={styles.navLink}>Redeem Code</Link>
                                {CONNECT_ENABLED && !this.props.room.roomOpen && <Link to="/connect" className={styles.navLink}>Connect</Link>}
                                {
                                    this.props.room.roomOpen ?
                                        <button onClick={() => this.props.navigate(this.props.room.isHost ? "/lobby" : "/join")} className={`${styles.button} ${styles.small}`}>RETURN TO LOBBY</button>
                                        :
                                        <>
                                            <button onClick={() => this.props.navigate("/join")} className={`${styles.button} ${styles.small}`}>JOIN A GAME</button>
                                            <button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.small} ${styles.blueAlt}`}>HOST A GAME</button>
                                        </>
                                }
                            </nav>
                        }
                        <div className={`${styles.mobileBar} d-flex d-lg-none`}>
                            {
                                !pathname.includes("play") && !limitAccessFireTv &&
                                <div className={styles.mobileButtons}>
                                    {this.props.room.roomOpen ?
                                        <button onClick={() => this.props.navigate(this.props.room.isHost ? "/lobby" : "/join")} className={`${styles.button} ${styles.small}`}>RETURN TO LOBBY</button>
                                        :
                                        <>
                                            <button onClick={() => this.props.navigate("/join")} className={`${styles.button} ${styles.small}`}>JOIN A GAME</button>
                                            <button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.small} ${styles.blueAlt}`}>HOST A GAME</button>
                                        </>
                                    }
                                </div>
                            }
                            {!limitAccessFireTv &&
                                <>
                                    <Link to="/checkout" className={`${styles.actionsItem} ${styles.mobileCartLink} d-none d-md-flex`}>
                                        <img src={basketIcon} alt="Cart" width="30" height="32" />
                                        {
                                            this.countCartQuanity() > 0 &&
                                            <p className={styles.basketCount}>{this.countCartQuanity()}</p>
                                        }
                                    </Link>
                                    <Dropdown onToggle={(isOpen) => this.setState({ mobileMenuOpen: isOpen })}>
                                        <Dropdown.Toggle
                                            as="div"
                                            id="mobile-bar-menu-dropdown"
                                            className={`${styles.actionsItem} dropdown-toggle--custom`}
                                        >
                                            <svg width="26" height="20" viewBox="0 0 26 20" fill="none" stroke="#261A31" strokeWidth="3" strokeLinecap="round">
                                                <line x1="2" y1="2" x2="24" y2="2"/>
                                                <line x1="2" y1="10" x2="24" y2="10"/>
                                                <line x1="2" y1="18" x2="24" y2="18"/>
                                            </svg>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu align="end" className={styles.mobileDropdown} >
                                            {this.props.auth.isLoggedIn && (
                                                <Dropdown.Item
                                                    className={styles.userNameMobile}
                                                    disabled
                                                >
                                                    {this.props.auth.user?.userName ||
                                                        this.props.auth.user?.email}
                                                </Dropdown.Item>
                                            )}
                                            <Dropdown.Item onClick={() => this.doNavigation("/checkout")}>
                                                Cart
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.doNavigation("/help")}>How it works</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.doNavigation("/shop")}>Browse all games</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.doNavigation("/articles")}>News</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.doNavigation("/go")}>On the Go</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.doNavigation("/redeem-code")}>Redeem Code</Dropdown.Item>
                                            {CONNECT_ENABLED && !this.props.room.roomOpen && <Dropdown.Item onClick={() => this.doNavigation("/connect")}>Connect</Dropdown.Item>}
                                            <Dropdown.Divider className={styles.menuDivider} />
                                            {this.props.auth.isLoggedIn ? (
                                                <>
                                                    <Dropdown.Item
                                                        className={styles.userMenuItem}
                                                        onClick={() => this.doNavigation("/my-account")}
                                                    >
                                                        My Account
                                                    </Dropdown.Item>
                                                    {
                                                        this.props.auth.user?.roomPin && this.props.auth.user?.roomPin.length > 0 &&
                                                        <Dropdown.Item
                                                            className={styles.userMenuItem}
                                                            onClick={() => this.doNavigation("/reset-pin")}
                                                        >
                                                            Reset PIN
                                                        </Dropdown.Item>
                                                    }
                                                    <Dropdown.Item
                                                        className={styles.userMenuItem}
                                                        onClick={this.logout}
                                                    >
                                                        Logout
                                                    </Dropdown.Item>
                                                </>
                                            ) : (
                                                <>
                                                    <Dropdown.Item
                                                        className={styles.userMenuItem}
                                                        onClick={() => this.setState({ showCRM: true, })}
                                                    >
                                                        Newsletter
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        className={styles.userMenuItem}
                                                        onClick={() => this.doNavigation("/login")}
                                                    >
                                                        Login
                                                    </Dropdown.Item>
                                                </>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </>
                            }
                        </div>
                        <div className={`${styles.menuItems} ${styles.actions} d-none d-lg-flex`}>
                            <ul>
                                {!this.props.auth.isLoggedIn && !limitAccessFireTv &&
                                    <li>
                                        <div className={styles.actionsItem} onClick={() => this.setState({ showCRM: true })} style={{ cursor: 'pointer' }}>
                                            <img src={newsletterIcon} alt="Newsletter" />
                                        </div>
                                    </li>
                                }
                                <li>
                                    {!limitAccessFireTv &&
                                        <>
                                            <Dropdown ref={this.wrapperRefTwo} className={`d-none d-md-block`}>
                                                <Dropdown.Toggle
                                                    as="div"
                                                    id="user-menu-dropdown"
                                                    className={`${styles.actionsItem} dropdown-toggle--custom`}
                                                >
                                                    {this.props.auth.isLoggedIn && (
                                                        <span className={styles.userName}>
                                                        {this.props.auth.user?.userName || this.props.auth.user?.email}
                                                        </span>
                                                    )}
                                                    <img src={userIcon} alt="User Menu" width="45" height="30" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu
                                                    align="end"
                                                    className={styles.menu}
                                                    style={{ backgroundColor: "#210f37" }}
                                                >
                                                    {this.props.auth.isLoggedIn && (
                                                        <Dropdown.Item
                                                            className={styles.userNameMobile}
                                                            disabled
                                                        >
                                                            {this.props.auth.user?.userName ||
                                                                this.props.auth.user?.email}
                                                        </Dropdown.Item>
                                                    )}

                                                    {this.props.auth.isLoggedIn ? (
                                                        <>
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={() => this.doNavigation("/my-account")}
                                                            >
                                                                My Account
                                                            </Dropdown.Item>
                                                            {
                                                                this.props.auth.user?.roomPin && this.props.auth.user?.roomPin.length > 0 &&
                                                                <Dropdown.Item
                                                                    className={styles.userMenuItem}
                                                                    onClick={() => this.doNavigation("/reset-pin")}
                                                                >
                                                                    Reset PIN
                                                                </Dropdown.Item>
                                                            }
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={this.logout}
                                                            >
                                                                Logout
                                                            </Dropdown.Item>
                                                        </>
                                                    ) : (
                                                        <Dropdown.Item
                                                            className={styles.userMenuItem}
                                                            onClick={() => this.doNavigation("/login")}
                                                        >
                                                            Login
                                                        </Dropdown.Item>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </>
                                    }
                                </li>
                                {limitAccessFireTv && isCurrentUserTheHost && (
                                    <li>
                                        <div
                                            className={styles.actionsItem}
                                            onClick={() => this.doNavigation("/my-account")}
                                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
                                        >
                                            <span className={styles.fireTvAccountLabel}>My Account</span>
                                            <img src={userIcon} alt="My Account" width="45" height="30" />
                                        </div>
                                    </li>
                                )}
                                {!limitAccessFireTv &&
                                    <>
                                        <li>
                                            <div className={`${styles.actionsItem} d-none d-md-flex`}>
                                                <Link to="/checkout" className={styles.basketIcon}>
                                                    <img src={basketIcon} alt="" width="42" height="45" data-basket-count={this.countCartQuanity()}></img>
                                                    {
                                                        this.countCartQuanity() > 0 &&
                                                        <p className={styles.basketCount}>{this.countCartQuanity()}</p>
                                                    }
                                                </Link>
                                            </div>
                                        </li>
                                        <li>
                                            <Dropdown className="d-lg-none">
                                                <Dropdown.Toggle
                                                    as="div"
                                                    id="menu-dropdown"
                                                    className={`${styles.actionsItem} dropdown-toggle--custom`}
                                                >
                                                    <img src={burgerMenu} alt="Menu" width="45" height="30" />
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu align="end" className={styles.menu} style={{ backgroundColor: "#210f37" }} >
                                                    {this.props.auth.isLoggedIn && (
                                                        <Dropdown.Item
                                                            className={styles.userNameMobile}
                                                            disabled
                                                        >
                                                            {this.props.auth.user?.userName ||
                                                                this.props.auth.user?.email}
                                                        </Dropdown.Item>
                                                    )}
                                                    <Dropdown.Item className={`d-flex d-md-none ${styles.basketIcon}`} onClick={() => this.doNavigation("/checkout")}>
                                                        Cart
                                                        {
                                                            this.countCartQuanity() > 0 &&
                                                            <p className={styles.basketCount}>{this.countCartQuanity()}</p>
                                                        }
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/help")}>How it works</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/shop")}>Browse all games</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/articles")}>News</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/go")}>On the Go</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.doNavigation("/redeem-code")}>Redeem Code</Dropdown.Item>
                                                    <Dropdown.Item className="d-flex d-md-none" onClick={() => this.doNavigation("/join")}>Join Game</Dropdown.Item>
                                                    <Dropdown.Item className="d-flex d-md-none" onClick={() => this.doNavigation("/lobby")}>Host Game</Dropdown.Item>
                                                    {CONNECT_ENABLED && !this.props.room.roomOpen && <Dropdown.Item onClick={() => this.doNavigation("/connect")}>Connect</Dropdown.Item>}

                                                    {this.props.auth.isLoggedIn ? (
                                                        <>
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={() => this.doNavigation("/my-account")}
                                                            >
                                                                My Account
                                                            </Dropdown.Item>
                                                            {
                                                                this.props.auth.user?.roomPin && this.props.auth.user?.roomPin.length > 0 &&
                                                                <Dropdown.Item
                                                                    className={styles.userMenuItem}
                                                                    onClick={() => this.doNavigation("/reset-pin")}
                                                                >
                                                                    Reset PIN
                                                                </Dropdown.Item>
                                                            }
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={this.logout}
                                                            >
                                                                Logout
                                                            </Dropdown.Item>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={() => this.setState({ showCRM: true, })}
                                                            >
                                                                Newsletter
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                className={styles.userMenuItem}
                                                                onClick={() => this.doNavigation("/login")}
                                                            >
                                                                Login
                                                            </Dropdown.Item>
                                                        </>

                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>
                                    </>
                                }
                            </ul>
                        </div>
                    </Container>
                </header>

                <CRMModal fromNav={true} show={this.state.showCRM} onClose={this.onCRMClose} />
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        cart: state.cart,
        devices: state.devices,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => {
            dispatch(logout())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavMenu));